'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchClientRecentImpacts = exports.editClient = exports.deleteClient = exports.fetchClient = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchClient = exports.fetchClient = function fetchClient(id) {
  return (0, _callApi2.default)('GET', '/client/' + id);
};
var deleteClient = exports.deleteClient = function deleteClient(id) {
  return (0, _callApi2.default)('DELETE', '/client/' + id);
};
var editClient = exports.editClient = function editClient(_ref) {
  var client = _ref.client,
      user = _ref.user;
  return (0, _callApi2.default)('PUT', '/client/' + id, { client: client, user: user });
};
var fetchClientRecentImpacts = exports.fetchClientRecentImpacts = function fetchClientRecentImpacts(id) {
  return (0, _callApi2.default)('GET', '/client/' + id + '/recent-impacts');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/client.js
// module id = 724
// module chunks = 0